module.exports = __webpack_public_path__ + "static/media/flappyrocketdavide.0561b9c7.jpg";